import { hasTrackingPermission } from '../mobile/appTracking';
import { isCordova, isIOS } from '../mobile/deviceDetection';
import { getConsent } from './consentState';

/**
 * Stored consent AND platform gate. On iOS, MARKETING additionally requires
 * App Tracking Transparency — ATT governs cross-app tracking (IDFA), which
 * only the advertising vendors touch. First-party statistics/analytics uses
 * no IDFA and therefore only needs the GDPR consent. Only reads the ATT
 * status: the prompt comes from the onboarding message or the cookie
 * settings, and an undetermined status counts as not granted.
 *
 * @param {'statistics' | 'marketing'} category
 * @returns {Promise<boolean>}
 */
const hasEffectiveConsent = async (category) => {
  const consent = getConsent();
  if (!consent || !consent[category]) return false;
  if (category === 'marketing' && isCordova() && isIOS()) {
    return hasTrackingPermission();
  }
  return true;
};

export default hasEffectiveConsent;
